<template>
  <svg class="icon icon-not-key" width="663" height="512" viewBox="0 0 663 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path
          d="M529.748 48.251C465.412 -16.085 360.735 -16.084 296.399 48.252C252.454 92.197 237.19 156.958 256.218 215.713L70.396 401.536C67.583 404.349 66.001 408.157 66.001 412.142V497C66.001 505.291 72.71 512 81.001 512H165.859C169.843 512 173.652 510.418 176.464 507.605L197.675 486.379C200.912 483.142 202.494 478.601 201.967 474.045L199.33 451.252L230.912 448.278C238.09 447.604 243.759 441.935 244.433 434.757L247.407 403.175L270.2 405.826C274.433 406.397 278.696 404.976 281.904 402.135C285.097 399.279 286.928 395.206 286.928 390.929V363H314.35C318.334 363 322.143 361.418 324.955 358.605L363.422 320.647C422.162 339.69 485.803 325.576 529.748 281.601C594.084 217.266 594.084 112.587 529.748 48.251ZM487.313 154.321C469.764 171.87 441.229 171.87 423.68 154.321C406.131 136.772 406.131 108.237 423.68 90.688C441.229 73.139 469.764 73.139 487.313 90.688C504.862 108.237 504.861 136.772 487.313 154.321Z"
          fill="black"/>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'IconKey'
}
</script>
